import React, { useState, useRef } from 'react'

const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`)
const days = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export type AvailabilityMatrix = boolean[][] // 7 days × 24 hours

export default function WeeklyAvailabilityGrid({
  value,
  onChange,
}: {
  value: AvailabilityMatrix
  onChange: (val: AvailabilityMatrix) => void
}) {
  const [isDragging, setIsDragging] = useState(false)
  const isSelecting = useRef(true) // are we selecting or deselecting?

  const handleMouseDown = (dayIdx: number, hourIdx: number) => {
    setIsDragging(true)
    const selecting = !value[dayIdx][hourIdx]
    isSelecting.current = selecting
    toggleCell(dayIdx, hourIdx, selecting)
  }

  const handleMouseOver = (dayIdx: number, hourIdx: number) => {
    if (isDragging) {
      toggleCell(dayIdx, hourIdx, isSelecting.current)
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  const toggleCell = (dayIdx: number, hourIdx: number, val: boolean) => {
    const updated = value.map((day, dIdx) =>
      day.map((hour, hIdx) => {
        if (dIdx === dayIdx && hIdx === hourIdx) return val
        return hour
      })
    )
    onChange(updated)
  }

  return (
    <div
      className="border border-gray-200 rounded-md overflow-auto"
      onMouseLeave={handleMouseUp}
      onMouseUp={handleMouseUp}
    >
      <div className="grid grid-cols-[80px_repeat(7,1fr)] text-sm text-center font-medium bg-gray-100 sticky top-0 z-10">
        <div></div>
        {days.map(day => (
          <div
            key={day}
            className="p-2 border-l border-gray-300 select-none pointer-events-none"
          >
            {day}
          </div>
        ))}
      </div>

      {hours.map((hour, hourIdx) => (
        <div key={hour} className="grid grid-cols-[80px_repeat(7,1fr)]">
          <div className="border-t border-gray-300 bg-gray-50 text-right pr-2 text-xs py-1 sticky left-0 z-10 select-none pointer-events-none">
            {hour}
          </div>
          {days.map((_, dayIdx) => {
            const selected = value[dayIdx][hourIdx]
            return (
              <div
                key={`${dayIdx}-${hourIdx}`}
                className={`h-8 cursor-pointer border-t border-l border-gray-200 ${
                  selected ? 'bg-blue-500' : 'bg-white'
                }`}
                onMouseDown={() => handleMouseDown(dayIdx, hourIdx)}
                onMouseOver={() => handleMouseOver(dayIdx, hourIdx)}
              />
            )
          })}
        </div>
      ))}
    </div>
  )
}
